import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Navigation.module.scss';

const Navigation: React.FC = () => {
  return (
    <nav className={styles.navContainer}>
      <div className={styles.navSection}>
        <h3 className={styles.navSectionTitle}>Main</h3>
        <ul className={styles.navList}>
          <li>
            <NavLink 
              to="/live" 
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Live & Upcoming Matches
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/matches" 
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Matches List
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/vod-highlights" 
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Highlights & Condensed Matches
            </NavLink>
          </li>
        </ul>
      </div>

      <div className={styles.navSection}>
        <h3 className={styles.navSectionTitle}>Management</h3>
        <ul className={styles.navList}>
          <li>
            <NavLink 
              to="/tournaments" 
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Tournaments
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/players" 
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Players
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/teams" 
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Teams
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/courts" 
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Complexes/Courts
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/feed-mapping" 
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Feed Mapping
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;

